import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpUtils } from '../utils/http-utils';
import { AdsTxtStatus } from '../domain/adstxt-status.model';
import { Domain } from '../domain/domain.model';
import { DomainWebStats } from '../../kitchen/shared/domain/domain-webstats.model';
import { AdsTxtDiff } from '../components/domain-specific/adstxt-diff-dialog.component';
import { SiteApprovalRequest, SiteApprovalResponse, SiteListResponse } from '../domain/site-approval-request.model';
import { DomainDpApproval } from '../domain/domain-dp-approval.model';
import { DomainDpChangedRequest, DomainDpChangedResponse, DpDomainApprovalsSummary } from '../domain/custom-domain-dp-approval.model';
import { BridgeAdUnitDpHbId } from '../domain/bridge-ad-unit-hb-id.model';
import { SitesCsvImportResult } from '../../demand-partner/domain/sites-csv-import-result.model';

@Injectable()
export class AdStatsAppsService {

  constructor(private http: HttpClient) {
  }

  appList(params: SiteApprovalRequest): Observable<SiteListResponse> {
    return this.http.get<SiteListResponse>(`${environment.serviceUrl}/ad-stats/domains/site-list?type=APP`, {
      params: HttpUtils.getHttpParams(params)
    });
  }

  domainsExport(params: SiteApprovalRequest) {
    return this.http.get(`${environment.serviceUrl}/ad-stats/domains/export`, {
      responseType: 'text',
      params: HttpUtils.getHttpParams(params)
    });
  }

  domainsCheckAppAdstxt(ids: string[]) {
    return this.http.post(`${environment.serviceUrl}/ad-stats/domains/check-appadstxt`, ids);
  }
}
